import { useSetRecoilState } from 'recoil'
import { stepState } from '../states/messageState'
import { useInViewFooter } from './useInViewFooter'
import { useSendMessage } from './useSendMessage'

export const useRequestFailed = () => {
  const { handleAddSenderParent } = useSendMessage()
  const { handleInViewFooter } = useInViewFooter()
  const setCurrentStep = useSetRecoilState(stepState)

  const requestFailed = async (isFulfilled?: boolean) => {
    const message = `申し訳ございません。${
      isFulfilled
        ? 'こちらの保証は既に使用されている為、利用する事が出来ません。'
        : '頂いた情報では保証契約が見つかりませんでした。\nまたは、保証期間がスタートしていない可能性も考えることができます。'
    }\nさらなるお問い合わせが必要な場合はcustomer@helloproteger.comか0570-081170 平日（月〜金）10:00~18:00へお問い合わせ下さい。`

    await handleAddSenderParent('bot', message)

    handleInViewFooter()
    setCurrentStep('notFoundInquiryCodeOrEmail')
  }

  return { requestFailed }
}
